import { getErrorHandlingState, getRequest } from 'app/selectors';
import { ErrorHandlingModal } from 'components/ErrorHandlingModal';
import { removeRequestError } from 'features/errorHandling/errorHandlingSlice';
import { RequestStatus } from 'features/request/requestSlice';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { AnyObject } from 'types/AnyObject';
import { ExportCSVReport } from 'utils/createCSVReportFile';

import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const GlobalErrorHandling = () => {
    const dispatch = useDispatch();

    const {
        requestData,
        requestStatus,
        requestError,
        requestId,
        title: modalTitle,
    } = useSelector(getErrorHandlingState);
    const { code } = useSelector(getRequest);

    const [resetRequestData] = useResetStoreData({
        requestId,
    });

    const handleCloseModalError = useCallback(() => {
        dispatch(removeRequestError());
        resetRequestData(null);
    }, [dispatch, resetRequestData]);

    const handleCreateReport = useCallback(() => {
        ExportCSVReport(requestData?.validation);
    }, [requestData?.validation]);

    return (
        (requestData || requestError) && (
            <ErrorHandlingModal
                titleText={modalTitle}
                isSubmitted={requestStatus !== RequestStatus.FETCHING}
                statusRequest={requestStatus}
                dataRequest={requestData}
                errorsRequest={requestError as AnyObject[]}
                requestCode={code}
                handleCloseModalError={handleCloseModalError}
                handleCreateReport={handleCreateReport}
            />
        )
    );
};

GlobalErrorHandling.displayName = 'GlobalErrorHandling';
